import { GET_PROFILE, CLEAR_PROFILE } from 'actions/type'

let initialState = {
  profile: {}
}

export default function profileReducer( state = initialState, action ) {
  switch( action.type ) {
    case GET_PROFILE:
      return {
        ...state,
        profile: action.payload
      }
    case CLEAR_PROFILE:
      return {
        ...state,
        profile: {}
      }
    default: return state
  }
}
